import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  HStack,
  Icon,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "phosphor-react";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.900" py={20}>
      <Container maxW="container.md">
        <VStack spacing={8} align="stretch">
          <HStack spacing={4}>
            <Button
              leftIcon={<Icon as={ArrowLeft} weight="bold" />}
              variant="ghost"
              color="white"
              onClick={() => navigate("/")}
              _hover={{ bg: "whiteAlpha.200" }}
            >
              Back to home
            </Button>
          </HStack>

          <Heading color="white" textAlign="center" size="2xl" mb={8}>
            Terms and conditions
          </Heading>

          <VStack spacing={8} align="stretch">
            <Box>
              <Text color="gray.300" fontSize="lg">
                These Terms and Conditions govern your access to and use of the
                Virtual Golf Society platform (the "Service"). By creating an
                account or using the Service, you agree to be bound by these
                Terms.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Eligibility and accounts
              </Heading>
              <UnorderedList color="gray.300" spacing={2} pl={4}>
                <ListItem>
                  You must provide accurate account information.
                </ListItem>
                <ListItem>
                  You are responsible for maintaining the confidentiality of
                  your credentials.
                </ListItem>
                <ListItem>
                  You are responsible for activity that occurs under your
                  account.
                </ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                User content
              </Heading>
              <UnorderedList color="gray.300" spacing={2} pl={4}>
                <ListItem>
                  You retain ownership of content you submit, post, or display
                  on the Service.
                </ListItem>
                <ListItem>
                  You grant us a license to host, store, reproduce, and display
                  your content as necessary to operate the Service.
                </ListItem>
                <ListItem>
                  You are responsible for your content and must have the rights
                  to share it.
                </ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Prohibited conduct
              </Heading>
              <UnorderedList color="gray.300" spacing={2} pl={4}>
                <ListItem>
                  Do not misuse the Service, interfere with its operation, or
                  attempt unauthorized access.
                </ListItem>
                <ListItem>
                  Do not post unlawful, abusive, or infringing content.
                </ListItem>
                <ListItem>
                  Do not impersonate others or misrepresent your affiliation.
                </ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Termination
              </Heading>
              <Text color="gray.300">
                We may suspend or terminate your access to the Service if you
                violate these Terms or if we reasonably believe it is necessary
                to protect the Service or other users.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Disclaimer
              </Heading>
              <Text color="gray.300">
                The Service is provided on an "as is" and "as available" basis.
                We do not warrant that the Service will be uninterrupted,
                secure, or error-free.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Updates to this policy
              </Heading>
              <Text color="gray.300">
                We may update these Terms from time to time. Continued use of
                the Service after changes become effective constitutes
                acceptance of the updated Terms.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Contact us
              </Heading>
              <Text color="gray.300">
                If you have any questions about our privacy policy or how we
                handle your personal information, please contact our privacy
                team at privacy@joinvgs.com
              </Text>
            </Box>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Terms;
